import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

import { getXCLEARCorrelationInfo } from '@api/utils'
import { session } from './session'
import { createAuthPipe } from './createAuthPipe'
import { detectFlow } from './utils'
import { useFlag } from '@hooks/useFlag'

export function useAuthPipe() {
  const router = useRouter()
  const group = useFlag('auth')
  const pipeRef = useRef<ReturnType<typeof createAuthPipe> | undefined>(
    undefined
  )
  const routeRef = useRef<string>('')
  const route = router.route

  if (!pipeRef.current || routeRef.current !== route) {
    routeRef.current = route
    const flow = detectFlow(
      route,
      router.query?.desiredPath as string | undefined
    )

    const enabled = `${group?.enabled}` /** hydrated and pending state */
    const variant = group
      ? group.enabled
        ? 'T1_ALL_UPDATES'
        : 'C_BASELINE'
      : 'pending'
    const uid = 'unknown'

    pipeRef.current = createAuthPipe({
      xCLEARCorrelationInfo: getXCLEARCorrelationInfo(),
      authFlowSessionId: session.authFlowSessionId,
      flow,
      route,
      experimentEnabled: enabled,
      experimentVariant: variant,
      experimentUID: uid,
    })
  }

  useEffect(() => {
    return () => {
      pipeRef.current = undefined
    }
  }, [])

  return pipeRef.current
}
